// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".666cef15-2487-4f95-ad5f-3bf0301fc1b3.js";
};